import React, { Component } from "react";

// Importar componentes
import Inicio from "../components/juegos/Inicio";
// import audio5 from "../assets/sound/narracion/5 letraa.mp3";

let audio = new Audio();

class Juego extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="col App-juego" id="Juego">
        <Inicio />
      </div>
    );
  }
}

export default Juego;
